module.exports = __webpack_public_path__ + "3aa86a3addbc33c684974484c27cfc22.jpg";